module.exports = __webpack_public_path__ + "static/media/enspiral.11c4fa1e.png";